import { configureStore } from "@reduxjs/toolkit";
import sliceHome from "../slice/home/sliceHome";
import sliceLanguage from "../slice/home/sliceLanguage";
import { apiHome } from "../services/internal/apiHome";
import { apiExternal } from "../services/external/apiExternal";
// import { apiExternalUat } from "../services/external/apiUat";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import { combineReducers } from "redux";

// Persist configuration
const persistConfig = {
  key: "root", // Key for storage
  storage, // Storage engine
  blacklist: ["sliceLanguage", apiHome.reducerPath, apiExternal.reducerPath],
};

// Combine reducers
const rootReducer = combineReducers({
  sliceHome,
  sliceLanguage,
  [apiHome.reducerPath]: apiHome.reducer,
  [apiExternal.reducerPath]: apiExternal.reducer,
  // [apiExternalUat.reducerPath]: apiExternalUat.reducer,
});

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .concat(apiHome.middleware)
      .concat(apiExternal.middleware),
});

// Create and export persistor
export const persistor = persistStore(store);
